import { call, put } from 'redux-saga/effects';
import {
  BusinessSizesMap,
  BusinessSizesResponse,
  getBusinessSizes,
} from '../api';
import {
  fetchBusinessSizesFailure,
  fetchBusinessSizesSuccess,
} from '../actions';
import { BusinessSize } from '../models';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchBusinessSizesSaga() {
  try {
    let err: ApiError | null;
    const response: BusinessSizesResponse = yield call(getBusinessSizes);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const businessSizes: BusinessSize[] = [];
    const businessSizesMap: BusinessSizesMap = response?.data.businessSizes;
    for (const key in businessSizesMap) {
      businessSizes.push({ id: key, name: businessSizesMap[key] });
    }
    yield put(fetchBusinessSizesSuccess(businessSizes));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchBusinessSizesFailure());
  }
}
